import AppContainer from '../../client/containers/appContainer'
import FeaturePageContainer from '../../client/containers/featurePageContainer'
import HomePageContainer from '../../client/containers/homePageContainer'
import LandingPageContainer from '../../client/containers/landingPageContainer'
import NotFoundPageContainer from '../../client/containers/notFoundPageContainer'
import TopSellersPageContainer from '../../client/containers/topSellersPageContainer'
import SearchCategoryPageProxy from '../../client/pages/searchCategoryPageProxy'

import { IRouteConfig, PageType } from '../../typings/routes'
import { newSearchRouteConfig, oldSearchRouteConfig } from './search'

const sharedRoutes: IRouteConfig[] = [
  {
    component: HomePageContainer,
    exact: true,
    path: '/',
    pageType: PageType.HOME
  },
  {
    component: FeaturePageContainer,
    exact: true,
    path: '/feature',
    pageType: PageType.FEATURE,
    searchBar: true
  },
  {
    component: TopSellersPageContainer,
    exact: true,
    path: '/top-sellers',
    pageType: PageType.POPULAR,
    searchBar: true
  },
  {
    component: TopSellersPageContainer,
    exact: true,
    path: '/popular_item/by_category',
    pageType: PageType.POPULAR,
    searchBar: true
  },
  {
    component: LandingPageContainer,
    path: '/free/:page',
    pageType: PageType.LANDING
  }
]

// Note: Router order does matter, make sure always put `path: '/*'` at the end of all router configs
const notFoundRoute: IRouteConfig = {
  component: NotFoundPageContainer,
  path: '/*',
  pageType: PageType.OTHER
}

export const newRoutes: IRouteConfig[] = [
  {
    component: AppContainer,
    path: '/',
    routes: [...sharedRoutes, ...newSearchRouteConfig, notFoundRoute]
  }
]

export const oldRoutes: IRouteConfig[] = [
  {
    path: '/',
    component: AppContainer,
    routes: [...sharedRoutes, ...oldSearchRouteConfig, notFoundRoute]
  }
]

export const oldRoutesWithCategoryPage: IRouteConfig[] = [
  {
    path: '/',
    component: AppContainer,
    routes: [
      ...sharedRoutes,
      {
        component: SearchCategoryPageProxy,
        path: '/category/wordpress',
        exact: true,
        pageType: PageType.CATEGORY
      },
      ...oldSearchRouteConfig,
      notFoundRoute
    ]
  }
]
